


export const clearFilterData = {
  ROTmSt: null,
  ROTmEn: null,
  DrvId: null,
  TukId: null,
  ROStsId: null
}
export const initFilterData = {
  ...clearFilterData,
  ROStsId: -1
  // ROTmSt: dayjs().format("YYYY-MM-DD 00:00:00"),
  // ROTmEn: dayjs().format("YYYY-MM-DD 23:59:59.997"),
}

export const initDialogData = {
  ROId: null,
  RONo: "",
  ROTm: null,
  ROStsId: 1,
  DrvId: null,
  TukId: null,
  OrdHdr: "",
  OrdDscp: "",
  ReprDscp: "",
  StDte: null,
  EstFinDte: null,
  FinDte: null,
}